require.register("startup", function(exports, require, module){
  const HandlebarsHelper = require("./handlebars-helper");
const LocaleService = require("services/locale-service");
const ComponentInit = require("javascripts/component-init");
const LearnerProfileService =
  require("services/learner-profile-service").default;
const EnrollmentDataService = require("services/enrollment-data-service");
const ef = require("ef/ef");
const utils = require("lib/utils");

var componentInit;

(function () {
  let configArr = [];
  // Special for this course... We want to make sure the specific mp3 file
  // exists in the current local language. If not, hide the "listen" button.
  // This should be page specific. If next page has the necessary mp3,
  // leave the button showing, etc.
  Chaplin.mediator.subscribe(
    "media:status:changed",
    (status, audioId, type) => {
      // don't do anything if it is not audio.
      if (type !== "audio") {
        return;
      }
      if (
        status === "playing" ||
        status === "completed" ||
        status === "paused"
      ) {
        // when audio is playing by button click or autoPlay, completing or pausing do not send another request. just show the button
        requestAnimationFrame(() => {
          $("button.audio").show();
        });
        return;
      }

      $.ajax({
        url: utils.coursePath(
          `audio/${LocaleService.getLanguage()}/${audioId}.mp3`
        ),
        dataType: "text",
        error: function () {
          $("button.audio").hide();
        },
        success: function () {
          $("button.audio").show();
        },
      });
    }
  );
  Chaplin.mediator.subscribe("page:state:initialized", function (view) {
    configArr = [];
    componentInit = new ComponentInit(view);
  });
  Chaplin.mediator.subscribe("page:custom:partial", function (configs) {
    configArr.push(configs);
  });
  Chaplin.mediator.subscribe("page:state:loaded", function () {
    requestAnimationFrame(() => {
      $("button.audio").hide(); //in case autoPlay is true and audio does not exist, we do not get media:status:changed event, hence hiding button
    });
    for (let i = 0; i < configArr.length; i++) {
      componentInit.configure(configArr[i]);
    }
    //Hides modules in the course menu that don't exist in the course
    EF.modulesJSON.forEach(({ key }) => {
      if (!EF.modules._byId[key]) {
        $(`.course-menu .${key}-course-menu-item`).hide();
      }
    });
  });
  // Saving org_type to enrollment for content swapping
  // console.log('loaded, LearnerProfileService', LearnerProfileService.data);
  if (LearnerProfileService.data) {
    var org_type;
    if (
      ["bsc-intro", "m06", "bsc-conclusion"].toString() ===
      EF.modules.models.map((m) => m.id).toString()
    ) {
      org_type = "BSC";
      LearnerProfileService.data.org_type = "BSC";
    } else {
      org_type = LearnerProfileService.get("org_type");
    }
    EnrollmentDataService.saveData("locale:namespace:prefix", org_type);
  } else {
    console.log("no learnerProfile data");
    return;
  }
  const bitrate = EnrollmentDataService.getData("bitrateIndex");
  if (bitrate === undefined) {
    const lqVideosCustomization = ef.customizations.getByKeyAndSlug(
      "data-option",
      "low-quality-videos"
    );
    if (lqVideosCustomization && lqVideosCustomization.text === "true") {
      EnrollmentDataService.saveData("bitrateIndex", 0);
    }
  }
})();

  
});

